import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
export function titleWithOptionalBranding(
  prefix: string,
  serviceTitle: string,
  brand: string,
  maxLength = 60
): string {
  const fullTitle = `${prefix} ${serviceTitle}`;
  const fullWithBrand = `${fullTitle} | ${brand}`;

  // Jika muat, tampilkan semua
  if (fullWithBrand.length <= maxLength) return fullWithBrand;

  // Jika judul saja sudah lebih panjang dari batas, potong judul
  if (fullTitle.length > maxLength) {
    return fullTitle.slice(0, maxLength - 1).trimEnd() + "…";
  }

  // Branding tidak muat, tampilkan hanya judul
  return fullTitle;
}

export function truncatedDesc(desc: string, maxLength = 155): string {
  if (desc.length <= maxLength) return desc;
  return desc.slice(0, maxLength - 1).trimEnd() + "…";
}
